import styled from 'styled-components';

export const Container = styled.li`
  position: relative;
  width: 100%;
  width: 50%;
  width: 100%;
  z-index: 2;
  float: left;
  margin-bottom: 40px;
  &.left {
    padding-right: 50%;
    & > div {
      /* padding-left: 70px;
      padding-right: 100px;
      &:before {
        right: 0;
        margin-right: -5px;
        border-radius: 50% 50% 0 50%;
      } */
    }
  }
  &.right {
    padding-left: 50%;
    /* margin-top: 290px; */
    & > div {
      /* padding-right: 70px;
      padding-left: 100px;
      &:before {
        left: 0;
        margin-left: -5px;
        border-radius: 50% 50% 50% 0;
      } */
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    &.left,
    &.right {
      margin-top: 0;
      padding-bottom: 120px;
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const Inner = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /* transform: translateY(-80px); */
  header {
    flex: 0 0 40%;
    max-width: 40%;
    h2 {
      color: #27357c;
      font-size: 30px;
      font-weight: 800;
      padding-bottom: 5px;
      text-transform: uppercase;
    }
    p {
      font-size: 25px;
      line-height: 33px;
      word-break: break-word;
      span {
        color: #831d13;
        font-weight: 700;
        display: block;
      }
    }
  }
  &.no-image {
    header {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  img {
    /* flex-grow: 1; */
    flex: 0 0 60%;
    max-width: 60%;
    width: 100%;
    /* max-width: 510px; */
    height: auto;
    cursor: pointer;
  }
  &:before {
    content: attr(data-order);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #27357c;
    width: 88px;
    height: 88px;
    color: #fff;
    font-size: 45px;
    font-weight: 900;
    top: 50%;
    transform: translateY(-50%);
  }
  li.left & {
    /* outline: solid 1px red; */
    padding-left: 70px;
    padding-right: 50px;
    header {
      padding-right: 44px;
      * {
        text-align: right;
      }
    }
    &:before {
      right: 0;
      margin-right: -5px;
      border-radius: 50% 50% 0 50%;
    }
  }
  li.right & {
    /* outline: solid 1px blue; */
    padding-right: 70px;
    padding-left: 75px;
    header {
      order: 2;
      padding-left: 44px;
      * {
        text-align: left;
      }
    }
    img {
      order: 1;
    }
    &:before {
      left: 0;
      margin-left: -5px;
      border-radius: 50% 50% 50% 0;
    }
  }
  @media (max-width: 1200px) {
    flex-direction: column;
    header,
    img {
      flex: 0 0 100%;
      max-width: 100%;
    }
    header {
      margin-bottom: 25px;
      order: 1;
      h2 {
        font-size: calc(100vw / 40);
      }
      p {
        font-size: calc(100vw / 45);
      }
    }
    img {
      order: 2;
    }
    li.left & {
      padding-left: 15px;
      header {
        padding-right: 0;
      }
    }
    li.right & {
      padding-right: 15px;
      header {
        padding-left: 0;
        order: 1;
      }
    }
  }
  @media (max-width: 768px) {
    li.left &,
    li.right & {
      padding-left: 70px;
      padding-right: 15px;
      margin-top: 0;
      &:before {
        left: 0;
        margin-left: 15px;
        border-radius: 50% 50% 50% 0;
        width: 60px;
        height: 60px;
        font-size: 35px;
      }
      header {
        * {
          text-align: left;
        }
        h2 {
          font-size: 25px;
        }
        p {
          font-size: 18px;
        }
      }
    }
  }
`;
